import Axios from 'axios'

export default (() => {
  const instance = Axios.create({
    responseType: 'json',
    headers: {
      'Content-Type': 'application/json',
    },
  })

  // Attach JWT auth header from localStorage on every request
  instance.interceptors.request.use((config) => {
    const token = window.localStorage.getItem('accessToken')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  })

  return instance
})()
